import React from 'react';
import styled from 'styled-components';
import { RadioIcon } from '@estee/elc-icons';

interface RadioIconProps {
  isChecked?: boolean;
  className?: string;
}

const StyledRadioIcon = styled(RadioIcon)`
  -webkit-mask-size: 29px;
  mask-size: 29px;
  &.disabled {
    opacity: 0.5;
  }
  display: inline-block;
`;

const RadioIconRC: React.FunctionComponent<RadioIconProps> = ({ isChecked, className }) => (
  <StyledRadioIcon
    className={className}
    isChecked={isChecked}
  />
);

export default RadioIconRC;
